export function getVisibleIndexes(
  rowHeight: number,
  viewPortHeight: number,
  scrollY: number,
  overscan = 10,
): {
  first: number
  last: number
} {
  return {
    first: Math.max(Math.floor(scrollY / rowHeight) - overscan, 0),
    last: Math.max(
      Math.floor((scrollY + viewPortHeight) / rowHeight) + overscan,
      0,
    ),
  }
}
